export default __webpack_public_path__ + "locales/vi/Webhooks.json?hash=a13d8cd1f34d8058ab6d9491eddf73b4";